/*
 * @Author: chenchaoqiang@leedarson.com
 * @Date: 2022-08-02 19:29:27
 * Copyright 2022 Leedarson, All Rights Reserved.
 */
import Native from './Native';
import NativeSystem from './NativeSystem';
import NativePayment from './NativePayment';
import NativeWebView from './NativeWebView';
import { JSBridge } from './types';

const _native = new Native();
const system = new NativeSystem({ native: _native });
const payment = new NativePayment({ native: _native });
const webView = new NativeWebView({ native: _native });
_native.register();

const native: JSBridge = {
  system,
  payment,
  webView,
};

export default native;
